import React, { useState } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import TrademarkOverview from "../components/TrademarkOverview";
import ServicesSection from "../components/ServicesSection";
import WhyChooseUs from "../components/WhyChooseUs";
import ProcessSection from "../components/ProcessSection";
import PricingSection from "../components/PricingSection";
import IndustriesServed from "../components/IndustriesServed";
import BenefitsSection from "../components/BenefitsSection";
import TrustSignals from "../components/TrustSignals";
import FAQSection from "../components/FAQSection";
import CTASection from "../components/CTASection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import ContactPopup from "../components/ContactPopup";

const HomePage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  return (
    <div className="homepage">
      <Header openPopup={openPopup} />
      <HeroSection openPopup={openPopup} />
      <AboutSection />
      <TrademarkOverview />
      <ServicesSection />
      <WhyChooseUs />
      <ProcessSection />
      <PricingSection openPopup={openPopup} />
      <IndustriesServed />
      <BenefitsSection />
      <TrustSignals />
      <FAQSection />
      <CTASection openPopup={openPopup} />
      <ContactSection />
      <Footer openPopup={openPopup} />
      <ContactPopup isOpen={isPopupOpen} onClose={closePopup} />
    </div>
  );
};

export default HomePage;
